// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 2vh;
        right: 0px;
        height: 95%;
        width: 0%;
        box-sizing: border-box;
        border-radius: 10px 0px 0px 10px;
        animation: customer-administrator-container-stretch-in 0.45s ease-out forwards;
    }
    @keyframes customer-administrator-container-stretch-in {
        from{
            width: 0%;
        }
        to{
            width: 70%;
        }
    }
    .customer-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .customer-container-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .customer-container-header p{
        margin: 0px;
        margin-right: 20px;
        font-weight: lighter;
        font-size: 30px;
        cursor: pointer;
    }
    .customer-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .customer-container-navigation-bar{
        padding: 20px;
        opacity: 0;
        animation: customer-container-navigation-bar-stretch-in 0.1s ease-in forwards 0.45s;
    }
    @keyframes customer-container-navigation-bar-stretch-in {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
    .customer-container-navigation-bar button{
        margin-right: 20px;
        padding: 8px 12px;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
        transition: background-color 0.5s ease;
    }
    .customer-container-navigation-bar button:hover{
        background-color: rgba(187, 35, 35, 0.952);
    }
    .customer-container-body{
        height: auto;
        max-height: 56vh;
        overflow: auto;
        padding: 0px 20px;
        opacity: 0;
        animation: customer-container-body-stretch-in 0.1s ease-in forwards 0.45s;
    }
    @keyframes customer-container-body-stretch-in {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
}
@media screen and (max-width:949px){
    .customer-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 0vh;
        right: 0px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .customer-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .customer-container-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .customer-container-header p{
        margin: 0px;
        cursor: pointer;
        font-size: 22px;
        margin-top: -5px;
        margin-right: 10px;
        box-sizing: border-box;
        font-weight: lighter;
    }
    .customer-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .customer-container-navigation-bar{
        width: 100%;
        display: flex;
        overflow: auto;
        align-items: center;
        box-sizing: border-box;
        padding: 20px!important;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    .customer-container-navigation-bar button{
        margin-right: 20px;
        padding: 8px 12px;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        white-space: nowrap;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
        transition: background-color 0.5s ease;
    }
    .customer-container-navigation-bar button:hover{
        background-color: rgba(187, 35, 35, 0.952);
    }
    .customer-container-body{
        height: auto;
        max-height: 56vh;
        overflow: auto;
        padding: 0px 20px;
    }
}
.customer-container-body-component{
    margin: 20px;
    border-radius: 5px;
    padding: 5px 10px;
    background-color: lightgray;
}
.customer-container-body-component p{
    margin: 0px;
    font-size: 10px;
    background-color: transparent;
}
.customer-container-body-component input{
    margin: 0px;
    outline: none;
    border: none;
    width: 100%;
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/Customer.css"],"names":[],"mappings":"AAAA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,SAAS;QACT,sBAAsB;QACtB,gCAAgC;QAChC,8EAA8E;IAClF;IACA;QACI;YACI,SAAS;QACb;QACA;YACI,UAAU;QACd;IACJ;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,+BAA+B;QAC/B,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,eAAe;IACnB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,aAAa;QACb,UAAU;QACV,mFAAmF;IACvF;IACA;QACI;YACI,UAAU;QACd;QACA;YACI,UAAU;QACd;IACJ;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,0CAA0C;QAC1C,0CAA0C;QAC1C,sCAAsC;IAC1C;IACA;QACI,0CAA0C;IAC9C;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,UAAU;QACV,yEAAyE;IAC7E;IACA;QACI;YACI,UAAU;QACd;QACA;YACI,UAAU;QACd;IACJ;AACJ;AACA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,gCAAgC;QAChC,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,WAAW;QACX,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,0CAA0C;QAC1C,0CAA0C;QAC1C,sCAAsC;IAC1C;IACA;QACI,0CAA0C;IAC9C;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,iBAAiB;IACrB;AACJ;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 2vh;\r\n        right: 0px;\r\n        height: 95%;\r\n        width: 0%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px 0px 0px 10px;\r\n        animation: customer-administrator-container-stretch-in 0.45s ease-out forwards;\r\n    }\r\n    @keyframes customer-administrator-container-stretch-in {\r\n        from{\r\n            width: 0%;\r\n        }\r\n        to{\r\n            width: 70%;\r\n        }\r\n    }\r\n    .customer-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 0px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .customer-container-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-container-header p{\r\n        margin: 0px;\r\n        margin-right: 20px;\r\n        font-weight: lighter;\r\n        font-size: 30px;\r\n        cursor: pointer;\r\n    }\r\n    .customer-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .customer-container-navigation-bar{\r\n        padding: 20px;\r\n        opacity: 0;\r\n        animation: customer-container-navigation-bar-stretch-in 0.1s ease-in forwards 0.45s;\r\n    }\r\n    @keyframes customer-container-navigation-bar-stretch-in {\r\n        from{\r\n            opacity: 0;\r\n        }\r\n        to{\r\n            opacity: 1;\r\n        }\r\n    }\r\n    .customer-container-navigation-bar button{\r\n        margin-right: 20px;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        color: white;\r\n        cursor: pointer;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n        transition: background-color 0.5s ease;\r\n    }\r\n    .customer-container-navigation-bar button:hover{\r\n        background-color: rgba(187, 35, 35, 0.952);\r\n    }\r\n    .customer-container-body{\r\n        height: auto;\r\n        max-height: 56vh;\r\n        overflow: auto;\r\n        padding: 0px 20px;\r\n        opacity: 0;\r\n        animation: customer-container-body-stretch-in 0.1s ease-in forwards 0.45s;\r\n    }\r\n    @keyframes customer-container-body-stretch-in {\r\n        from{\r\n            opacity: 0;\r\n        }\r\n        to{\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 0vh;\r\n        right: 0px;\r\n        height: 100%;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px;\r\n    }\r\n    .customer-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 10px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .customer-container-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-container-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n        font-size: 22px;\r\n        margin-top: -5px;\r\n        margin-right: 10px;\r\n        box-sizing: border-box;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .customer-container-navigation-bar{\r\n        width: 100%;\r\n        display: flex;\r\n        overflow: auto;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n        padding: 20px!important;\r\n        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .customer-container-navigation-bar button{\r\n        margin-right: 20px;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        color: white;\r\n        cursor: pointer;\r\n        white-space: nowrap;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n        transition: background-color 0.5s ease;\r\n    }\r\n    .customer-container-navigation-bar button:hover{\r\n        background-color: rgba(187, 35, 35, 0.952);\r\n    }\r\n    .customer-container-body{\r\n        height: auto;\r\n        max-height: 56vh;\r\n        overflow: auto;\r\n        padding: 0px 20px;\r\n    }\r\n}\r\n.customer-container-body-component{\r\n    margin: 20px;\r\n    border-radius: 5px;\r\n    padding: 5px 10px;\r\n    background-color: lightgray;\r\n}\r\n.customer-container-body-component p{\r\n    margin: 0px;\r\n    font-size: 10px;\r\n    background-color: transparent;\r\n}\r\n.customer-container-body-component input{\r\n    margin: 0px;\r\n    outline: none;\r\n    border: none;\r\n    width: 100%;\r\n    background-color: transparent;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
